var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.esEdicion
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.esEdicion
                          ? "Editar Despacho"
                          : "Ver Detalle Despacho"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.esEdicion
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm ||
                                  _vm.btnBloquear ||
                                  _vm.btnBloquearGuardado
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-form",
                              {
                                ref: "form",
                                staticClass: "col-md-12",
                                attrs: { "lazy-validation": "" },
                                model: {
                                  value: _vm.validForm,
                                  callback: function($$v) {
                                    _vm.validForm = $$v
                                  },
                                  expression: "validForm"
                                }
                              },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { "grid-list-md": "" } },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { align: "left" } },
                                      [
                                        _c("v-flex", { attrs: { md12: "" } }, [
                                          _c(
                                            "h2",
                                            {
                                              staticClass: "h2_title",
                                              staticStyle: {
                                                "margin-top": "12px !important"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.esEdicion
                                                      ? "Editar Despacho"
                                                      : "Ver Detalle Despacho"
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c("br"),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:80",
                                                  expression: "'max:80'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields.codigo.label,
                                                disabled: true,
                                                counter: 80
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.codigo.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.codigo,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.codigo.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("DatePicker", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.fechaEnvio
                                                    .label,
                                                "data-vv-name":
                                                  "fechaEnvioRequerida",
                                                "error-messages": _vm.errors.collect(
                                                  "fechaEnvioRequerida"
                                                ),
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.fechaEnvio
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.fechaEnvio,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.fechaEnvio.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:80",
                                                  expression: "'max:80'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields.usuario.label,
                                                disabled: true,
                                                counter: 80
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.usuario.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.usuario,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.usuario.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.courier.label,
                                                items: _vm.courrierList,
                                                "item-text": "configvalor",
                                                "item-value": "configid",
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.courier.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.courier,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.courier.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:50",
                                                  expression: "'max:50'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields
                                                    .ordenSeguimiento.label,
                                                disabled: true,
                                                counter: 50
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields
                                                    .ordenSeguimiento.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields
                                                      .ordenSeguimiento,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.ordenSeguimiento.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.localidad
                                                    .label,
                                                items: _vm.localidadList,
                                                "item-text": "locaname",
                                                "item-value": "locaname",
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.localidad
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.localidad,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.localidad.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.coordinador
                                                    .label,
                                                items: _vm.coordinadorList,
                                                "item-text": "coorname",
                                                "item-value": "coorname",
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.coordinador
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.coordinador,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.coordinador.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.tecnico.label,
                                                items: _vm.tecnicoList,
                                                "item-text": "tecniconame",
                                                "item-value": "tecniconame",
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.tecnico.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.tecnico,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.tecnico.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:100",
                                                  expression: "'max:100'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields.observacion
                                                    .label,
                                                disabled: true,
                                                counter: 100
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.observacion
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.observacion,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.observacion.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs1: "", sm1: "", md1: "" }
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.costo.label,
                                                disabled: true
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.costo.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.costo,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.costo.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs3: "", sm3: "", md3: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:50",
                                                  expression: "'max:50'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields.valor.label,
                                                disabled: true,
                                                counter: 50,
                                                type: "Number"
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.valor.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.valor,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.valor.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("DatePicker", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.fechaRecepcion
                                                    .label,
                                                "data-vv-name":
                                                  "fechaRecepcionRequerida",
                                                "error-messages": _vm.errors.collect(
                                                  "fechaRecepcionRequerida"
                                                ),
                                                disabled:
                                                  !_vm.esEdicion ||
                                                  _vm.existeFechaR
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.fechaRecepcion
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields
                                                      .fechaRecepcion,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.fechaRecepcion.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-text-field", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "max:50",
                                                  expression: "'max:50'"
                                                }
                                              ],
                                              attrs: {
                                                label:
                                                  _vm.formFields.receptor.label,
                                                disabled:
                                                  !_vm.esEdicion ||
                                                  _vm.existereceptor,
                                                counter: 50
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.receptor.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.receptor,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.receptor.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: { xs4: "", sm4: "", md4: "" }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.anular.label,
                                                items:
                                                  _vm.formFields.anular.items,
                                                disabled:
                                                  !_vm.esEdicion || _vm.anulado
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.anular.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.anular,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.anular.value"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Módulo"
          }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }